import Vue from "vue";
import axios from "axios";
import moment from 'moment';
import router from '@/router';

export default {
  namespaced: true,
  state: {
    currentCase: {
      id: "",
      complaint: "Non-Payment of Rent",
      createPropertyType: "",
      property: {},
      propertyId: -1,
      buildingNo: null,
      tenantInfoCorrect: "",
      tenants: [],
      tenantsSaved: true,
      tenantType: "",
      tenantPhone: "",
      tenantEmail: "",
      leaseTypeTitle: "",
      leaseTypeCategory: "",
      leaseStartDate: null,
      mileagePrice: 0,
      mileageNeighborhood: "",
      mileageAnswer: 0,
      signatureImage: "",
      signatureText: "",
      section8: "",
      rentCycle: "",
      rentDueBy: "",
      rentAmount: 0,
      section8Subsidy: 0,
      section8TenantPortion: 0,
      publicHousingOfficeSection8: null,
      pastDueRent: [],
      additionalChargesPermitted: null,
      lateCharges: [],
      utilities: [],
      fees: [],
      otherCharges: [],
      legalFeesPermitted: null,
      legalFees: "",
      feesTotal: 0,
      documentsUploadPermitted: null,
      documents: [],
      attorneyId: null,
      serviceId: null,
      filingPlan: "",
      confirmation: {
        military_tenant: {
          text:
            "To your knowledge, no tenant in the property is a member of the United States Armed Forces, and the premises is not used for dwelling of the spouse, a child or other dependents of a person in the military.",
          confirmed: true,
        },
        registered_leasehold: {
          text:
            "The landlord has registered the leasehold and notified tenant as required by <b>N.J.S.A. 46:8-27</b>.",
          confirmed: true,
        },
        ownership: {
          text:
            "The landlord has acquired ownership of the property from the tenants.",
          confirmed: false,
        },
        option_to_purchase: {
          text:
            "The landlord has given the tenant(s) the option to purchase the property.",
          confirmed: false,
        },
        additional_reasons: {
          text:
            "The landlord seeks a judgment for possession for the additional or alternative reason(s) stated in the notices attached to this complaint.",
          confirmed: false,
        },
        tenant_continues_possession: {
          text:
            "The tenant(s) has/have not surrendered possession of the premises and tenant(s) hold(s) over and continues in possession without the consent of landlord.",
          confirmed: true,
        },
      },
      verification: {
        read_info_true: {
          text:
            "I have read the verified complaint and the information contained in it is true and based upon my personal knowledge.",
          confirmed: true,
        },
        another_court_subject: {
          text:
            "The matter in controversy is not the subject of another court action or arbitration now pending or contemplated and no other parties should be joined in this action.",
          confirmed: true,
          party: "",
          action: "",
        },
        // another_party: {
        //   text: "There is another party that should be joined in this action.",
        //   confirmed: false,
        //   party: "",
        // },
        confidential_personal_removed: {
          text:
            "I certify that confidential personal identifiers have been redacted from documents now submitted to the court, and will be redacted from all documents submitted in the future in accordance with Rule 1:38-7(b).",
          confirmed: true,
        },
        statements_true: {
          text:
            "The foregoing statements made by me are true and I am aware that if any of the foregoing statements made by me are willfully false, I am subject to punishment.",
          confirmed: true,
        },
        interpreter: {
          text: "At the trial, Plaintiff will require an interpreter.",
          confirmed: false,
          language: "",
        },
        disability: {
          text:
            "At the trial, Plaintiff will require an accommodation for a disability.",
          confirmed: false,
          accommodation: "",
        },
      },
      signature: "",
      rentDueBeforeTrial: "",
    },
    courtInfo: {},
    mileage: {},
    cases: [],
    orderDetails: {},
    orders: [
      "Tenant Information",
      "Lease Details",
      "Past Due Rent",
      "Additional Charges",
      "Legal Fees",
      "Documents",
      "Confirmation",
      "Verification",
      "Mileage",
      "Summary of Suit Amount",
      "Filing",
      "Review & Sign"
    ],
    steps: {
      property: {
        text: "Property",
        status: "",
        linkname: "select-property",
        // status: "",
        // dropdown: false,
        showChildren: false,
        children: {
          type: {
            text: "Property Type",
            status: "",
            linkname: "vc-property-type",
          },
          address: {
            text: "Property Address",
            status: "",
            linkname: "vc-property-address",
          },
          registration: {
            text: "Registration",
            status: "",
            linkname: "vc-property-registration",
          },
          owner: {
            text: "Owner Information",
            status: "",
            linkname: "vc-property-owner",
          },
          associationToOwner: {
            text: "Association to Owner",
            status: "",
            linkname: "vc-property-association-to-owner",
          },
          contact: {
            text: "Contact Information",
            status: "",
            linkname: "vc-client-contact",
          },
        },
      },
      tenant: {
        text: "Tenant Information",
        status: "",
        linkname: "vc-tenants",
      },
      leaseDetails: {
        text: "Lease Details",
        status: "",
        linkname: "vc-lease-details",
      },
      pastDueRent: {
        text: "Past Due Rent",
        status: "",
        linkname: "vc-past-due-rent",
      },
      additionalCharges: {
        text: "Additional Charges",
        status: "",
        linkname: "vc-additional-charges",
      },
      legalFees: {
        text: "Legal Fees",
        status: "",
        linkname: "vc-legal-fees",
      },
      document: { text: "Documents", status: "", linkname: "vc-documents" },
      confirmation: {
        text: "Confirmation",
        status: "",
        linkname: "vc-confirmation",
      },
      verification: {
        text: "Verification",
        status: "",
        linkname: "vc-verification",
      },
      mileage: {
        text: "Mileage",
        status: "",
        linkname: "vc-mileage",
      },
      suitSummary: {
        text: "Summary of Suit Amount",
        status: "",
        linkname: "vc-suit-summary",
      },
      filingPlan: {
        text: "Filing",
        status: "",
        linkname: "vc-filing",
      },
      sign: {
        text: "Review & Sign",
        status: "",
        linkname: "vc-signature",
      },
    },
    loading: false,
    evictionAppLoaded: false,
  },
  mutations: {
    set_current_case(state, payload) {
      Vue.set(state, "currentCase", payload);
    },
    init_case(state) {
      Vue.set(state, "currentCase", {
        id: "",
        complaint: "Non-Payment of Rent",
        createPropertyType: "",
        property: {},
        propertyId: -1,
        buildingNo: null,
        tenantInfoCorrect: "",
        tenants: [],
        tenantsSaved: true,
        tenantType: "",
        tenantPhone: "",
        tenantEmail: "",
        leaseTypeTitle: "",
        leaseTypeCategory: "",
        leaseStartDate: null,
        mileagePrice: 0,
        mileageNeighborhood: "",
        signatureImage: "",
        signatureText: "",
        mileageAnswer: 0,
        section8: "",
        rentCycle: "",
        rentDueBy: "",
        rentAmount: 0,
        section8Subsidy: 0,
        section8TenantPortion: 0,
        publicHousingOfficeSection8: null,
        pastDueRent: [],
        additionalChargesPermitted: null,
        lateCharges: [],
        utilities: [],
        fees: [],
        otherCharges: [],
        legalFeesPermitted: null,
        legalFees: "",
        feesTotal: 0,
        documentsUploadPermitted: null,
        documents: [],
        attorneyId: null,
        serviceId: null,
        filingPlan: "",
        confirmation: {
          military_tenant: {
            text:
              "To your knowledge, no tenant in the property is a member of the United States Armed Forces, and the premises is not used for dwelling of the spouse, a child or other dependents of a person in the military.",
            confirmed: true,
          },
          registered_leasehold: {
            text:
              "The landlord has registered the leasehold and notified tenant as required by <b>N.J.S.A. 46:8-27</b>.",
            confirmed: true,
          },
          ownership: {
            text:
              "The landlord has acquired ownership of the property from the tenants.",
            confirmed: false,
          },
          option_to_purchase: {
            text:
              "The landlord has given the tenant(s) the option to purchase the property.",
            confirmed: false,
          },
          additional_reasons: {
            text:
              "The landlord seeks a judgment for possession for the additional or alternative reason(s) stated in the notices attached to this complaint.",
            confirmed: false,
          },
          tenant_continues_possession: {
            text:
              "The tenant(s) has/have not surrendered possession of the premises and tenant(s) hold(s) over and continues in possession without the consent of landlord.",
            confirmed: true,
          },
        },
        verification: {
          read_info_true: {
            text:
              "I have read the verified complaint and the information contained in it is true and based upon my personal knowledge.",
            confirmed: true,
          },
          another_court_subject: {
            text:
              "The matter in controversy is not the subject of another court action or arbitration now pending or contemplated and no other parties should be joined in this action.",
            confirmed: true,
            party: "",
            action: "",
          },
          // another_party: {
          //   text:
          //     "There is another party that should be joined in this action.",
          //   confirmed: false,
          //   party: "",
          // },
          confidential_personal_removed: {
            text:
              "I certify that confidential personal identifiers have been redacted from documents now submitted to the court, and will be redacted from all documents submitted in the future in accordance with Rule 1:38-7(b).",
            confirmed: true,
          },
          statements_true: {
            text:
              "The foregoing statements made by me are true and I am aware that if any of the foregoing statements made by me are willfully false, I am subject to punishment.",
            confirmed: true,
          },
          interpreter: {
            text: "At the trial, Plaintiff will require an interpreter.",
            confirmed: false,
            language: "",
          },
          disability: {
            text:
              "At the trial, Plaintiff will require an accommodation for a disability.",
            confirmed: false,
            accommodation: "",
          },
        },
        signature: "",
        rentDueBeforeTrial: "",
      });
    },
    init_steps(state) {
      Vue.set(state, "steps", {
        property: {
          text: "Property",
          status: "",
          linkname: "select-property",
          // status: "",
          // dropdown: false,
          showChildren: false,
          children: {
            type: {
              text: "Property Type",
              status: "",
              linkname: "vc-property-type",
            },
            address: {
              text: "Property Address",
              status: "",
              linkname: "vc-property-address",
            },
            registration: {
              text: "Registration",
              status: "",
              linkname: "vc-property-registration",
            },
            owner: {
              text: "Owner Information",
              status: "",
              linkname: "vc-property-owner",
            },
            associationToOwner: {
              text: "Association to Owner",
              status: "",
              linkname: "vc-property-association-to-owner",
            },
            contact: {
              text: "Contact Information",
              status: "",
              linkname: "vc-client-contact",
            },
          },
        },
        tenant: {
          text: "Tenant Information",
          status: "",
          linkname: "vc-tenants",
        },
        leaseDetails: {
          text: "Lease Details",
          status: "",
          linkname: "vc-lease-details",
        },
        pastDueRent: {
          text: "Past Due Rent",
          status: "",
          linkname: "vc-past-due-rent",
        },
        additionalCharges: {
          text: "Additional Charges",
          status: "",
          linkname: "vc-additional-charges",
        },
        legalFees: {
          text: "Legal Fees",
          status: "",
          linkname: "vc-legal-fees",
        },
        document: { text: "Documents", status: "", linkname: "vc-documents" },
        confirmation: {
          text: "Confirmation",
          status: "",
          linkname: "vc-confirmation",
        },
        verification: {
          text: "Verification",
          status: "",
          linkname: "vc-verification",
        },
        mileage: {
          text: "Mileage",
          status: "",
          linkname: "vc-mileage",
        },
        suitSummary: {
          text: "Summary of Suit Amount",
          status: "",
          linkname: "vc-suit-summary",
        },
        filingPlan: {
          text: "Filing",
          status: "",
          linkname: "vc-filing",
        },
        sign: {
          text: "Review & Sign",
          status: "",
          linkname: "vc-signature",
        },
      });
    },
    update_current_case(state, subCase) {
      console.log("update_current_case was called:", subCase)
      const currentCaseInstance = Object.assign({}, state.currentCase);

      for (const key in subCase) {
        currentCaseInstance[key] = subCase[key];
      }

      Vue.set(state, "currentCase", currentCaseInstance);
    },
    set_cases(state, cases) {
      const sortedCases = cases.sort(function(a, b) { return new Date(a.updated_at) - new Date(b.updated_at) }).reverse();
      Vue.set(state, "cases", sortedCases);
    },
    sort_cases(state, sortDirection) {
      if(sortDirection === 'desc') {
        const sortedCases = state.cases.sort(function(a, b) { return new Date(a.updated_at) - new Date(b.updated_at) });
        Vue.set(state, "cases", sortedCases);
      } else {
        const sortedCases = state.cases.sort(function(a, b) { return new Date(a.updated_at) - new Date(b.updated_at) }).reverse();
        Vue.set(state, "cases", sortedCases);
      }
    },
    set_loading(state, flag) {
      Vue.set(state, "loading", flag);
    },
    set_eviction_app_loaded(state, flag) {
      state.evictionAppLoaded = flag;
    },
    set_steps(state, steps) {
      Vue.set(state, "steps", steps);
    },
    set_court_info(state, courtInfo) {
      Vue.set(state, "courtInfo", courtInfo);
    },
    set_mileage(state, mileage) {
      Vue.set(state, "mileage", mileage);
    },
    set_order_details(state, orderDetails) {
      Vue.set(state, "orderDetails", orderDetails);
    },
    update_steps(state, steps) {
      const currentCaseSteps = Object.assign({}, state.steps);

      for (const key in steps) {
        currentCaseSteps[key] = steps[key];
      }

      //*Expand 'property' if it's in this route (when user reloads page)
      const { path } = router.currentRoute
      if(path.includes("property")) currentCaseSteps.property.showChildren = true;
      
      Vue.set(state, "steps", currentCaseSteps);
    }
    
  },
  actions: {
    useCaseLocalStorage({ commit }, currentCaseInstance) {
      const getCaseLocalStorage = JSON.parse(localStorage.getItem('case'));
      Object.entries(getCaseLocalStorage).map(([key, value]) => currentCaseInstance[key] = value);
      commit("update_current_case", currentCaseInstance);
    },
    // eslint-disable-next-line
    loadCases({ commit, getters, rootState, rootGetters }) {
      if (!rootGetters.isAuthenticated) return;
      commit("set_loading", true);

      axios
        .get(`${process.env.VUE_APP_URL}/client/cases`, {
          params: {
            clientId: rootGetters.client.id,
          },
        })
        .then((r) => r.data)
        .then((data) => {
          commit("set_cases", data);
          commit("set_loading", false);
        });
    },
    // eslint-disable-next-line
    async loadCase({ dispatch, commit, getters, rootState, rootGetters }, { caseId, logMessage, fullLoad }) {
      commit("set_loading", true);
      if (process.env.NODE_ENV !== "production") {
        console.log(`eviction/loadCase is dispatched from ${logMessage}`);
      }

      /* Shimon temp
        if(getters.currentCase.id == caseId) {
        //*To prevent re-fetching this case and property.
        const casePropertyId = getters.currentCase.propertyId;
        const currentPropertyId = rootGetters['property/currentProperty'].propertyId;

        if(casePropertyId == currentPropertyId) return console.log("already loaded case and property");
        //* case is loaded, but not property
        await dispatch('property/loadProperty', casePropertyId, { root: true });
        return;
      }

        const caseRes = await axios.get(`${process.env.VUE_APP_URL}/case/${caseId}`)
        const { data } = caseRes;
        await dispatch('property/loadProperty', data.propertyId, { root: true });
      */
      let currentCaseInstance = Object.assign({}, getters.currentCase);

      const authenticated = rootGetters.isAuthenticated;

      if (!authenticated) {
        dispatch('useCaseLocalStorage', currentCaseInstance)
        return;
      }

      await dispatch('loadDocuments', { caseId: caseId || 'new' })

      return axios
        .get(`${process.env.VUE_APP_URL}/case/${parseInt(caseId)}`)
        .then((r) => r.data)
        .then(async (data) => {
          commit("set_loading", false);

          currentCaseInstance.id = data.id;
          currentCaseInstance.complaint = data.complaint;
          currentCaseInstance.property = {
            buildingNo: data.buildingNo,
            city: data.city,
            clientType: data.clientType,
            county: data.county,
            deedNames: data.deedNames,
            ownershipType: data.ownershipType,
            propertyId: data.propertyId,
            registrationDocumentName: data.registrationDocumentName,
            registrationFiled: data.registrationFiled,
            state: "New Jersey",
            streetAddress: data.streetAddress,
            subdivision: data.subdivision,
            zipcode: data.zipcode,
            unitNo: data.unitNo
          };
          currentCaseInstance.status = data.status;
          currentCaseInstance.statusDate = data.statusDate;
          currentCaseInstance.propertyId = data.propertyId;
          currentCaseInstance.tenantInfoCorrect =
            data.tenants.length > 0 ? "yes" : "";
          currentCaseInstance.tenants = data.tenants;
          currentCaseInstance.tenantsSaved = data.tenants.length > 0;
          currentCaseInstance.tenantType =
            data.tenants.length > 0 ? data.tenants[0].tenantType : "";
          currentCaseInstance.tenantPhone =
            data.tenants.length > 0 ? data.tenants[0].phone : "";
          currentCaseInstance.tenantEmail =
              data.tenants.length > 0 ? data.tenants[0].email : "";
          currentCaseInstance.leaseTypeTitle = data.leaseTypeTitle;
          currentCaseInstance.leaseTypeCategory = data.leaseTypeCategory;
          currentCaseInstance.leaseStartDate = data.leaseStartDate;
          currentCaseInstance.mileageNeighborhood = data.mileageNeighborhood;
          currentCaseInstance.mileageAnswer = data.mileageAnswer;
          currentCaseInstance.signatureImage = data.signatureImage;
          currentCaseInstance.signatureText = data.signatureText;
          currentCaseInstance.section8 = data.section8;
          currentCaseInstance.rentCycle = data.rentCycle;
          currentCaseInstance.rentDueBy =
            data.rentCycle === "Semi-monthly"
              ? data.rentDueBy.split(", ")
              : data.rentDueBy;
          currentCaseInstance.rentAmount = data.rentAmount;
          currentCaseInstance.section8Subsidy = data.section8Subsidy;
          currentCaseInstance.section8TenantPortion = data.section8TenantPortion;
          currentCaseInstance.publicHousingOfficeSection8 = JSON.parse(data.publicHousingOfficeSection8);
          currentCaseInstance.confirmation = JSON.parse(data.confirmation);
          currentCaseInstance.pastDueRent = data.pastDueRent
            ? JSON.parse(data.pastDueRent)
            : [];
          currentCaseInstance.additionalChargesPermitted = data.additionalChargesPermitted;
          currentCaseInstance.lateCharges = data.lateCharges
            ? JSON.parse(data.lateCharges)
            : [];
          currentCaseInstance.utilities = data.utilities
            ? JSON.parse(data.utilities)
            : [];
          currentCaseInstance.fees = data.fees ? JSON.parse(data.fees) : [];
          currentCaseInstance.otherCharges = data.otherCharges
            ? JSON.parse(data.otherCharges)
            : [];
          currentCaseInstance.legalFeesPermitted = data.legalFeesPermitted;
          currentCaseInstance.legalFees = data.legalFees
            ? JSON.parse(data.legalFees)
            : [];
          currentCaseInstance.documentsUploadPermitted = data.documentsUploadPermitted;
          // currentCaseInstance.documents: [],
          currentCaseInstance.attorneyId = data.attorneyId;
          currentCaseInstance.serviceId = data.servicePlanId;
          currentCaseInstance.filingPlan = data.filingPlan;
          if (getters.currentCase.documents.length) {
            currentCaseInstance.documents = getters.currentCase.documents
          }

          if (data.propertyId) {
            let properties = await dispatch('property/loadProperties', null, { root: true })
            if (properties) {
              const currentProperty = properties.find((p) => p.propertyId === data.propertyId);
              currentProperty && commit("property/set_current_property", currentProperty, { root: true });
            }
          }

          const clientData = rootGetters.client;

          const responseVerificationData = JSON.parse(data.verification);

          if (clientData) {
            currentCaseInstance.verification = {
              ...currentCaseInstance.verification,
              another_court_subject: {
                ...currentCaseInstance.verification.another_court_subject,
                confirmed: responseVerificationData?.another_court_subject.confirmed || true,
                party: responseVerificationData?.another_court_subject.party || "",
                action: responseVerificationData?.another_court_subject.action || "",
              },
              interpreter: {
                ...currentCaseInstance.verification.interpreter,
                confirmed: !!clientData.interpreter,
                language: clientData.language,
              },
              disability: {
                ...currentCaseInstance.verification.disability,
                confirmed: !!clientData.disability,
                accommodation: clientData.accommodation,
              },
            }
          }
          
          commit("update_current_case", currentCaseInstance);

          let a = getters.caseSteps;
          const currentStepKey = Object.keys(a).find(
            (key) => a[key].text === currentCaseInstance.status
          );

          if (currentStepKey || currentCaseInstance.status === "Verified Complaint Complete") {
            let currentStepIndex = Object.keys(a).length * 2;
            Object.keys(a).map((key, index) => {
              if (key === currentStepKey) currentStepIndex = index;
              if (index <= currentStepIndex) {// key !== currentStepKey && 
                a[key].status = "completed";
                if(key === 'property') {
                  
                  Object.keys(a['property'].children).map((child_key) => {
                    a['property'].children[child_key].status = "completed"
                  });
                }
              }
            });
            commit("update_steps", a);
          }

          if (typeof fullLoad === "undefined") {
            await dispatch('loadMileage');
            await dispatch('getCourtInfoByCountyName');
          }

          commit("set_eviction_app_loaded", true)

          return Promise.resolve(data);
        });      
    },
    createCase({ commit, getters, rootGetters }, { caseData, submitted, lastStep, createTenant, nextPath, logMessage }) {
      if (process.env.NODE_ENV !== "production") {
        console.log(`eviction/createCase is dispatched from ${logMessage}`);
      }

      if (!rootGetters.isAuthenticated) {
        // save to localStorage for when user creates account
        const newCase = {
          ...caseData,
          documents: [],
          status: lastStep ? lastStep : null,
          actionId: 171,
          submitted: submitted,
        }

        localStorage.setItem("hasGuestFlow", "1");
        localStorage.setItem("case", JSON.stringify(newCase));
        commit("set_current_case", newCase);

        let a = getters.caseSteps;
        let currentStepKey = 'tenant';
        if (currentStepKey) {
          let currentStepIndex = Object.keys(a).length * 2;
          Object.keys(a).map((key, index) => {
            if (key === currentStepKey) currentStepIndex = index;
            if (index <= currentStepIndex) { //key !== currentStepKey &&
              a[key].status = "completed";
              if(key === 'property') {
                Object.keys(a['property'].children).map((child_key) => {
                  a['property'].children[child_key].status = "completed"
                });
              }
            }
          });

          commit("update_steps", a);
        }

        nextPath && router.push({ name: nextPath, params: { id: "new" } });
        return;
      }

      let currentCaseInstance = Object.assign({}, getters.currentCase);
      
      return axios.post(`${ process.env.VUE_APP_URL }/createCase`, {
        caseInfo: caseData,
        clientId: rootGetters.client.id,
        status: lastStep ? lastStep : null,
        actionId: 171,
        submitted: submitted,
        createTenant
      })
        .then((r) => r.data)
        .then((data) => {
          currentCaseInstance.id = data.id;
          currentCaseInstance.complaint = data.complaint;
          currentCaseInstance.property = {
            buildingNo: data.buildingNo,
            city: data.city,
            clientType: data.clientType,
            county: data.county,
            deedNames: data.deedNames,
            ownershipType: data.ownershipType,
            propertyId: data.propertyId,
            registrationDocumentName: data.registrationDocumentName,
            registrationFiled: data.registrationFiled,
            state: "New Jersey",
            streetAddress: data.streetAddress,
            subdivision: data.subdivision,
            zipcode: data.zipcode,
          };
          currentCaseInstance.status = data.status;
          currentCaseInstance.statusDate = data.statusDate;
          currentCaseInstance.propertyId = data.propertyId;
          currentCaseInstance.tenantInfoCorrect =
                data.tenants.length > 0 ? "yes" : "";
          currentCaseInstance.tenants = data.tenants;
          currentCaseInstance.tenantsSaved = data.tenants.length > 0;
          currentCaseInstance.tenantType =
                data.tenants.length > 0 ? data.tenants[0].tenantType : "";
          currentCaseInstance.tenantPhone =
                data.tenants.length > 0 ? data.tenants[0].phone : "";
          currentCaseInstance.tenantEmail =
                  data.tenants.length > 0 ? data.tenants[0].email : "";
          currentCaseInstance.leaseTypeTitle = data.leaseTypeTitle;
          currentCaseInstance.leaseTypeCategory = data.leaseTypeCategory;
          currentCaseInstance.leaseStartDate = data.leaseStartDate;
          currentCaseInstance.mileageNeighborhood = data.mileageNeighborhood;
          currentCaseInstance.mileageAnswer = data.mileageAnswer;
          currentCaseInstance.signatureImage = data.signatureImage;
          currentCaseInstance.signatureText = data.signatureText;
          currentCaseInstance.section8 = data.section8;
          currentCaseInstance.confirmation = JSON.parse(data.confirmation);
          currentCaseInstance.rentCycle = data.rentCycle;
          currentCaseInstance.rentDueBy =
                data.rentCycle === "Semi-monthly"
                  ? data.rentDueBy.split(", ")
                  : data.rentDueBy;
          currentCaseInstance.rentAmount = data.rentAmount;
          currentCaseInstance.pastDueRent = data.pastDueRent
            ? JSON.parse(data.pastDueRent)
            : [];
          currentCaseInstance.additionalChargesPermitted = data.additionalChargesPermitted;
          currentCaseInstance.lateCharges = data.lateCharges
            ? JSON.parse(data.lateCharges)
            : [];
          currentCaseInstance.utilities = data.utilities
            ? JSON.parse(data.utilities)
            : [];
          currentCaseInstance.fees = data.fees ? JSON.parse(data.fees) : [];
          currentCaseInstance.otherCharges = data.otherCharges
            ? JSON.parse(data.otherCharges)
            : [];
          currentCaseInstance.legalFeesPermitted = data.legalFeesPermitted;
          currentCaseInstance.legalFees = data.legalFees
            ? JSON.parse(data.legalFees)
            : [];
          currentCaseInstance.documentsUploadPermitted = data.documentsUploadPermitted;
          // currentCaseInstance.documents: [],
          currentCaseInstance.attorneyId = data.attorneyId;
          currentCaseInstance.serviceId = data.servicePlanId;
          currentCaseInstance.filingPlan = data.filingPlan;

          if (data.propertyId) {
            const properties = rootGetters['property/properties']
            const currentProperty = properties.find((p) => p.propertyId === data.propertyId);
            currentProperty && commit("property/set_current_property", currentProperty, { root: true });
          } 
              
          commit("update_current_case", currentCaseInstance);
              
          //commit("update_current_case", { ...caseData, ...data});

          let a = getters.caseSteps;
          let currentStepKey = 'tenant';
          if (currentStepKey) {
            let currentStepIndex = Object.keys(a).length * 2;
            Object.keys(a).map((key, index) => {
              if (key === currentStepKey) currentStepIndex = index;
              if (index <= currentStepIndex) { //key !== currentStepKey && 
                a[key].status = "completed";
                if(key === 'property') {
                  Object.keys(a['property'].children).map((child_key) => {
                    a['property'].children[child_key].status = "completed"
                  });
                }
              }
            });
            commit("update_steps", a);
          }

          nextPath && router.push({ name:nextPath,params:{ id:data.id } })

          return Promise.resolve(data)
        });
         
    },
    updateCase({ commit, state, getters, rootGetters }, { caseData, submitted, dontMutate, lastStep }) {
      let currentCaseInstance = Object.assign({}, getters.currentCase);

      if (!rootGetters.isAuthenticated) {
        const storageCase = localStorage.getItem("case")
        const caseInfo = {
          ...JSON.parse(storageCase),
          ...caseData,
          statusDate: moment().format("MM.DD.YY"),
        }
        const updatedCase = {
          ...caseInfo,
          status: lastStep || null,
          submitted,
        }

        localStorage.setItem("hasGuestFlow", "1");
        localStorage.setItem("case", JSON.stringify(updatedCase));

        if (typeof dontMutate !== "undefined") {
          commit("update_current_case", updatedCase);
        } else {
          commit("update_current_case", updatedCase);
        }


        let a = getters.caseSteps;
        const currentStepKey = Object.keys(a).find((key) => a[key].text === lastStep);

        if (currentStepKey) {
          let currentStepIndex = Object.keys(a).length * 2;
          Object.keys(a).map((key, index) => {
            if (key === currentStepKey) currentStepIndex = index;
            if (index <= currentStepIndex) {// key !== currentStepKey &&
              a[key].status = "completed";
              if(key === 'property') {
                Object.keys(a['property'].children).map((child_key) => {
                  a['property'].children[child_key].status = "completed"
                });
              }
            }
          });

          commit("update_steps", a);
        }

        return;
      }

      return axios.post(`${process.env.VUE_APP_URL}/case/${getters.currentCase.id}`, {
        caseInfo: {
          ...getters.currentCase,
          ...caseData,
          statusDate: moment().format("MM.DD.YY"),
        },
        clientId: rootGetters.client.id,
        submitted: submitted,
        status: submitted ? "Verified Complaint Complete" : (state.orders.indexOf(lastStep) > state.orders.indexOf(getters.currentCase.status) ? lastStep : getters.currentCase.status),
      })
        .then((r) => r.data)
        .then((data) => {
          if (typeof dontMutate !== "undefined") return;

          currentCaseInstance.id = data.id;
          currentCaseInstance.complaint = data.complaint;
          currentCaseInstance.property = {
            buildingNo: data.buildingNo,
            city: data.city,
            clientType: data.clientType,
            county: data.county,
            deedNames: data.deedNames,
            ownershipType: data.ownershipType,
            propertyId: data.propertyId,
            registrationDocumentName: data.registrationDocumentName,
            registrationFiled: data.registrationFiled,
            state: "New Jersey",
            streetAddress: data.streetAddress,
            subdivision: data.subdivision,
            zipcode: data.zipcode,
          };
          currentCaseInstance.status = data.status;
          currentCaseInstance.statusDate = data.statusDate;
          currentCaseInstance.propertyId = data.propertyId;
          currentCaseInstance.tenantInfoCorrect =
          data.tenants.length > 0 ? "yes" : "";
          currentCaseInstance.tenants = data.tenants;
          currentCaseInstance.tenantsSaved = data.tenants.length > 0;
          currentCaseInstance.tenantType =
          data.tenants.length > 0 ? data.tenants[0].tenantType : "";
          currentCaseInstance.tenantPhone =
          data.tenants.length > 0 ? data.tenants[0].phone : "";
          currentCaseInstance.tenantEmail =
            data.tenants.length > 0 ? data.tenants[0].email : "";
          currentCaseInstance.leaseTypeTitle = data.leaseTypeTitle;
          currentCaseInstance.leaseTypeCategory = data.leaseTypeCategory;
          currentCaseInstance.leaseStartDate = data.leaseStartDate;
          currentCaseInstance.mileageNeighborhood = data.mileageNeighborhood;
          currentCaseInstance.mileageAnswer = data.mileageAnswer;
          currentCaseInstance.signatureImage = data.signatureImage;
          currentCaseInstance.signatureText = data.signatureText;
          currentCaseInstance.section8 = data.section8;
          currentCaseInstance.section8Subsidy = data.section8Subsidy;
          currentCaseInstance.section8TenantPortion = data.section8TenantPortion;
          currentCaseInstance.publicHousingOfficeSection8 = JSON.parse(data.publicHousingOfficeSection8);
          currentCaseInstance.confirmation = JSON.parse(data.confirmation);
          currentCaseInstance.rentCycle = data.rentCycle;
          currentCaseInstance.rentDueBy =
          data.rentCycle === "Semi-monthly"
            ? data.rentDueBy.split(", ")
            : data.rentDueBy;
          currentCaseInstance.rentAmount = data.rentAmount;
          currentCaseInstance.pastDueRent = data.pastDueRent
            ? JSON.parse(data.pastDueRent)
            : [];
          currentCaseInstance.additionalChargesPermitted = data.additionalChargesPermitted;
          currentCaseInstance.lateCharges = data.lateCharges
            ? JSON.parse(data.lateCharges)
            : [];
          currentCaseInstance.utilities = data.utilities
            ? JSON.parse(data.utilities)
            : [];
          currentCaseInstance.fees = data.fees ? JSON.parse(data.fees) : [];
          currentCaseInstance.otherCharges = data.otherCharges
            ? JSON.parse(data.otherCharges)
            : [];
          currentCaseInstance.legalFeesPermitted = data.legalFeesPermitted;
          currentCaseInstance.legalFees = data.legalFees
            ? JSON.parse(data.legalFees)
            : [];
          currentCaseInstance.documentsUploadPermitted = data.documentsUploadPermitted;
          currentCaseInstance.attorneyId = data.attorneyId;
          currentCaseInstance.serviceId = data.servicePlanId;
          currentCaseInstance.filingPlan = data.filingPlan;
          if (getters.currentCase.documents.length) {
            currentCaseInstance.documents = getters.currentCase.documents
          }

          const clientData = rootGetters.client;

          const responseVerificationData = JSON.parse(data.verification);

          if (clientData) {
            currentCaseInstance.verification = {
              ...currentCaseInstance.verification,
              another_court_subject: {
                ...currentCaseInstance.verification.another_court_subject,
                confirmed: responseVerificationData.another_court_subject.confirmed,
                party: responseVerificationData.another_court_subject.party,
                action: responseVerificationData.another_court_subject.action,
              },
              interpreter: {
                ...currentCaseInstance.verification.interpreter,
                confirmed: !!clientData.interpreter,
                language: clientData.language,
              },
              disability: {
                ...currentCaseInstance.verification.disability,
                confirmed: !!clientData.disability,
                accommodation: clientData.accommodation,
              },
            }
          }



          //* this is overriding the property with wrong info
          // if (data.propertyId) {
          //   const properties = rootGetters['property/properties']
          //   const currentProperty = properties.find((p) => p.propertyId === data.propertyId);
          //   currentProperty && commit("property/set_current_property", currentProperty, { root: true });
          // } 
        
          commit("update_current_case", currentCaseInstance);
          //commit("update_current_case", data);

          let a = getters.caseSteps;
          const currentStepKey = Object.keys(a).find(
            (key) => a[key].text === lastStep
          );
        
          if (currentStepKey) {
            let currentStepIndex = Object.keys(a).length * 2;
            Object.keys(a).map((key, index) => {
              if (key === currentStepKey) currentStepIndex = index;
              if (index <= currentStepIndex) {// key !== currentStepKey && 
                a[key].status = "completed";
                if(key === 'property') {
                  Object.keys(a['property'].children).map((child_key) => {
                    a['property'].children[child_key].status = "completed"
                  });
                }
              }
            });

            commit("update_steps", a);
          }
        
          return Promise.resolve(data)
        });
    },
    sortCases({ commit }, sortDirection) {
      commit("sort_cases", sortDirection);
    },
    async loadDocuments({ commit, getters, rootGetters }, { caseId, logMessage }) {
      if (process.env.NODE_ENV !== "production" && typeof logMessage !== "undefined") {
        console.log(`eviction/loadDocuments is dispatched from ${logMessage}`);
      }

      const currentCaseInstance = Object.assign({}, getters.currentCase);

      if (!rootGetters.isAuthenticated) {
        const documentFileData = localStorage.getItem('document_file_data');

        if (documentFileData) {
          const currentDocumentsCase = currentCaseInstance.documents.length ? [...currentCaseInstance.documents] : [];
          currentDocumentsCase.push(JSON.parse(documentFileData));
          currentCaseInstance.documents = currentDocumentsCase;
          commit("update_current_case", currentCaseInstance);
        }

        return;
      }

      const { data } = await axios.get(`${process.env.VUE_APP_URL}/uploads?caseId=${caseId}`);

      currentCaseInstance.documents = data;
      commit("update_current_case", currentCaseInstance);
    },
    async getCourtInfoByCountyName({ commit, getters }) {
      let courtInfoObj = Object.assign({}, getters.courtInfo);
      const countyName = getters.currentCase.property.county;
      const { data }  = await axios.get(`${process.env.VUE_APP_URL}/courtServiceInfo?countyName=${countyName}`);
      courtInfoObj = data;
      commit('set_court_info', courtInfoObj);
    },
    async getOrderByCaseId({ commit,getters }, { caseId, logMessage }) {
      if (process.env.NODE_ENV !== "production") {
        console.log(`eviction/getOrderByCaseId is dispatched from ${logMessage}`);
      }

      let orderDetailsObj = Object.assign({}, getters.orderDetails);

      try {
        const { data } = await axios.get(`${process.env.VUE_APP_URL}/api/getOrderByCaseId?caseId=${caseId}`);

        orderDetailsObj = data;

        commit('set_order_details', orderDetailsObj);
      } catch ({ response }) {
        console.log(response.message);
      }
    },
    async createOrder({ commit, getters }, { payload }) {
      let orderDetailsObj = Object.assign({}, getters.orderDetails);

      try {
        const { data } = await axios.post(`${process.env.VUE_APP_URL}/api/orders`, {
          caseId: payload.caseId,
          clientId: payload.clientId,
          orderNumber: payload.orderNumber,
          payment_status: payload.payment_status,
        })

        orderDetailsObj = data;

        commit('set_order_details', orderDetailsObj);
      } catch ({ response }) {
        console.log(response.message);
      }
    },
    async loadMileage({ commit, getters, rootGetters }) {
      let mileageObj = Object.assign({}, getters.mileage);

      const responses = await Promise.all([
        axios.get(`${process.env.VUE_APP_URL}/api/mileages/court-addresses`),
        axios.get(`${process.env.VUE_APP_URL}/api/mileages/mileage-areas`)
      ]);

      const getCurrentCaseCounty = typeof rootGetters['property/currentProperty'].county !== "undefined" ? rootGetters['property/currentProperty'].county.trim() : '';

      mileageObj.courtAddress = responses[0].data.find(item => item.county.trim() === getCurrentCaseCounty);
      mileageObj.areas = responses[1].data.filter(item => item.county.trim() === getCurrentCaseCounty);

      commit('set_mileage', mileageObj);
    },
  },
  getters: {
    currentCase: (state) => state.currentCase,
    cases: (state) => state.cases,
    caseSteps: (state) => state.steps,
    loading: (state) => state.loading,
    mileage: (state) => state.mileage,
    courtInfo: (state) => state.courtInfo,
    orderDetails: (state) => state.orderDetails,
    orders: (state) => state.orders,
    evictionAppLoaded: (state) => state.evictionAppLoaded,
  },
};
